import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { backButton } from '@telegram-apps/sdk-react';
import { motion } from 'framer-motion';

import PhotoShape from '@/components/common/svg/shapes/PhotoShape.tsx';
import ErrorShape from '@/components/common/svg/shapes/ErrorShape.tsx';
import {
  buttonShapeStyles,
  buttonStyles,
  containerStyles,
  contentHeaderStyles,
  contentMessageStyles,
  contentShapeStyles,
  contentStyles
} from '@/components/Verification/styles.ts';
import { routes } from '@/navigation/routes.tsx';
import { useWebSocketStore } from '@/store/useWebSocketStore.ts';

const VerificationFailed = ({ bottom }: { bottom?: string }) => {
  const { i18n, t } = useTranslation();
  const { setLastEvents } = useWebSocketStore();
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    navigate(routes.registrationUserPhotos);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const lang = searchParams.get('lang');

    if (lang && i18n.language !== lang) {
      void i18n.changeLanguage(lang);
    }

    if (backButton.isVisible()) {
      backButton.hide();
    }

    return () => {
      setLastEvents({ userVerified: undefined });
    };
  }, []);

  return (
    <div style={containerStyles}>
      <div style={contentStyles}>
        <ErrorShape
          width={70}
          height={70}
          fillColor="#b4b6bc"
          style={contentShapeStyles}
        />
        <span style={contentHeaderStyles}>
          {t('verification.failed.page.header')}
        </span>
        <p style={contentMessageStyles}>
          {t('verification.failed.page.message')}
        </p>
      </div>

      <motion.div
        onClick={handleClick}
        whileTap={{ scale: 0.9 }}
        style={buttonStyles(bottom)}
      >
        <PhotoShape width={23} height={23} fillColor="#FFF" />
        <span style={buttonShapeStyles}>
          {t('verification.failed.page.button')}
        </span>
      </motion.div>
    </div>
  );
};

export default VerificationFailed;
